import * as firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import { SSO_ENABLED_CLIENTS } from '../../constants/constants';

const DEV_COLLECTIONS = {
	chats: 'chats-dev',
	faculties: 'faculty-dev',
	leaves: 'leaves-dev',
	parents: 'parents-dev',
	posts: 'posts-dev',
	rosters: 'rosters-dev',
	school: 'school',
	students: 'students-dev',
	checkin: 'checkin-dev',
	calendar: 'calendar-dev',
	toth: 'toth-dev'
}

const PRODUCTION_COLLECTIONS = {
	chats: 'chats',
	faculties: 'faculty',
	leaves: 'leaves',
	parents: 'parents',
	posts: 'posts',
	rosters: 'rosters',
	school: 'school',
	students: 'students',
	checkin: 'checkin',
	calendar: 'calendar',
	toth: 'toth'
}

const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY

export const config = {
	apiKey: API_KEY,
	authDomain: "thehillschool.firebaseapp.com",
	databaseURL: "https://wave-490b0.firebaseio.com",
	projectId: "wave-490b0",
	storageBucket: "wave-490b0.appspot.com",
	messagingSenderId: "1030710416719"
};


export const COLLECTIONS = process.env.REACT_APP_FIREBASE_ENV !== 'wave490b0' ? PRODUCTION_COLLECTIONS : DEV_COLLECTIONS

// export const reactFirestore= <ReactFirestore firebase={firebase}/>

class Firebase {
	constructor() {
		firebase.initializeApp(config);
		/* Helper */

		this.provider = new firebase.auth.SAMLAuthProvider('saml.wave-saml');
		this.main = firebase;
		this.fieldValue = firebase.firestore.FieldValue;
		this.emailAuthProvider = firebase.auth.EmailAuthProvider;
		// this.id = firebase.iid.getId()
		this.auth = firebase.auth();
		this.db = firebase.firestore();
		this.storage = firebase.storage()
		// this.db.settings({timestampsInSnapshots: true});
		this.messaging = firebase.messaging.isSupported() ? firebase.messaging() : null
	}

	getSamlProvider = (providerId) => (new firebase.auth.SAMLAuthProvider(`saml.${providerId}`));

	onAuthUserListener = (next, fallback) =>
		this.auth.onAuthStateChanged(authUser => {
			if (authUser) {
				this.user(authUser.uid)
					.get()
					.then(snapshot => {
						const dbUser = snapshot.data();

						// default empty roles
						if (!dbUser.roles) {
							dbUser.roles = [];
						}

						// merge auth and db user
						authUser = {
							uid: authUser.uid,
							email: authUser.email,
							emailVerified: authUser.emailVerified,
							providerData: authUser.providerData,
							...dbUser,
						};

						next(authUser);
					});
			} else {
				fallback();
			}
		});

	doMessageService = async () => {
		if ('serviceWorker' in navigator) {
			window.addEventListener('load', async () => {
				const registration = await navigator.serviceWorker.register('../../../firebase-messaging-sw.js', {
					updateViaCache: 'none'
				});
				if (firebase.messaging.isSupported()) {
					this.messaging.useServiceWorker(registration);
				}
			});
		}
	};


	fieldValue = () => this.fieldValue;
	doSignInWithEmailAndPassword = (email, password) => this.auth.signInWithEmailAndPassword(email, password);

	doSignInWitSAML = async (email) => {
		const clientDomain = email.replace(/.*@/, "");
		this.auth.signInWithRedirect(this.getSamlProvider(SSO_ENABLED_CLIENTS[clientDomain]));
		// this.auth.getRedirectResult()
		// 	.then((result) => {
		// 		// User is signed in.
		// 		// Identity provider data available in result.additionalUserInfo.profile,
		// 		// or from the user's ID token obtained via result.user.getIdToken()
		// 		// as an object in the firebase.sign_in_attributes custom claim
		// 		// This is also available via result.user.getIdTokenResult()
		// 		// idTokenResult.claims.firebase.sign_in_attributes.
		// 		console.log('getRedirectResult-success',result)
		// 	})
		// 	.catch((error) => {
		// 		// Handle error.
		// 		console.log('getRedirectResult-error',error)
		// 	});
	}

	doSignOut = () => this.auth.signOut();

	doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

	doPasswordUpdate = password =>
		this.auth.currentUser.updatePassword(password);

	doGetIdToken = () => this.auth.currentUser.getIdToken(true);


	chats = () => this.db.collection(`${COLLECTIONS.chats}`);
	faculties = () => this.db.collection(`${COLLECTIONS.faculties}`);
	leaves = () => this.db.collection(`${COLLECTIONS.leaves}`);
	parents = () => this.db.collection(`${COLLECTIONS.parents}`);
	posts = () => this.db.collection(`${COLLECTIONS.posts}`);
	rosters = () => this.db.collection(`${COLLECTIONS.rosters}`);
	schools = () => this.db.collection(`${COLLECTIONS.school}`);
	students = () => this.db.collection(`${COLLECTIONS.students}`);
	checkins = () => this.db.collection(`${COLLECTIONS.checkin}`)


	post = (uid) => this.db.doc(`${COLLECTIONS.posts}/${uid}`);
	chat = (uid) => this.db.doc(`${COLLECTIONS.chats}/${uid}`);
	faculty = (uid) => this.db.doc(`${COLLECTIONS.faculties}/${uid}`);
	leave = (uid) => this.db.doc(`${COLLECTIONS.leaves}/${uid}`);
	parent = (uid) => this.db.doc(`${COLLECTIONS.parents}/${uid}`);
	roster = (uid) => this.db.doc(`${COLLECTIONS.rosters}/${uid}`);
	school = (uid) => this.db.doc(`${COLLECTIONS.school}/${uid}`);
	student = (uid) => this.db.doc(`${COLLECTIONS.students}/${uid}`)
	checkin = (uid) => this.db.doc(`${COLLECTIONS.checkin}/${uid}`)

	categories = () => this.db.collection(`${COLLECTIONS.calendar}`)
	category = (uid) => this.db.doc(`${COLLECTIONS.calendar}/${uid}`)
	calendarSchedules	= (uid) => this.db.doc(`${COLLECTIONS.calendar}/${uid}`).collection('schedule')
	calendarSchedule	= (uid, scheduleID) => this.db.doc(`${COLLECTIONS.calendar}/${uid}/schedule/${scheduleID}`)
	calendarSubcategories	= (uid) => this.db.doc(`${COLLECTIONS.calendar}/${uid}`).collection('subcategory')
	calendarSubcategory	= (uid, scheduleID) => this.db.doc(`${COLLECTIONS.calendar}/${uid}/subcategory/${scheduleID}`)

	// allToth = () => this.db.collection(`${COLLECTIONS.toth}`)
	toth = () => this.db.collection(`${COLLECTIONS.toth}`)

	// Cloud Function 
	modifyAuth = (uid, disabled) => {
		const updateAuthUser = firebase.functions().httpsCallable('updateAuthUser');
		updateAuthUser({uid, disabled}).then((result) => {
			console.log('success');
		})
		.catch(err => {
			console.log('err:', err)
		});
	}
}	

export default Firebase;
